import React, {useRef, useState} from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TextField from "@mui/material/TextField";
import TableContainer from "@mui/material/TableContainer";
import {v4} from "uuid";
import CreateIcon from '@mui/icons-material/Create';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DialogContent from "@mui/material/DialogContent";
import Dialog from "@mui/material/Dialog";
import CheckIcon from '@mui/icons-material/Check';
import DialogActions from "@mui/material/DialogActions";
import ClearIcon from '@mui/icons-material/Clear';
import AddIcon from "@mui/icons-material/Add";
import {useSignals} from "@preact/signals-react/runtime";
import {s_char, s_char_notes} from "../../_signals/s_char";
import {ICharNote} from "../../_interfaces/ICharNote";
import {NotesCreate, NotesDelete, NotesUpdate} from "../../_api/BENotes";
import {date2Timestamp} from "../../_helper/dates";

function Notes() {
    useSignals()

    const [open, setOpen] = useState(false)
    const [edit, setEdit] = useState(false)
    const [note, setNote] = useState<ICharNote | null>(null)

    const noteRef = useRef<HTMLInputElement | null>(null);

    const notesRow = (row: ICharNote) => {
        return <TableRow key={row.id}>
            <TableCell style={{width: 'auto'}}>
                {row.entry}
            </TableCell>
            <TableCell style={{width: '1%', textAlign: 'right', paddingRight: 0}}>
                <Button className={'btn'} id="post" onClick={() => openEdit(row)}>
                    <CreateIcon/>
                </Button>
            </TableCell>
        </TableRow>
    }

    const save = () => {
        let notes = s_char_notes.value;

        if (!edit) {
            if (noteRef.current && noteRef.current.value !== '') {
                let addNote = note;
                if (addNote) {
                    addNote.entry =noteRef.current.value
                    NotesCreate(addNote);
                    notes.unshift(addNote);
                    s_char_notes.value = notes
                }
            }
        } else {
            const foundIndex = notes.findIndex(x => x.id === note?.id);
            if (foundIndex >= 0 && noteRef.current) {
                notes[foundIndex].entry = noteRef.current.value;
                NotesUpdate(notes[foundIndex])
                s_char_notes.value = notes
            }
        }

        setNote(null)
        setOpen(false)
    }

    const cancel = () => {
        setNote(null)
        setOpen(false);
    }

    const openEdit = (note: ICharNote) => {
        setNote(note)
        setEdit(true)
        setOpen(true);
    }

    const add = () => {
        const ts = new Date()
        let addNote: ICharNote = {
            id: v4(),
            cid: s_char.value.id,
            ts: date2Timestamp(ts),
            entry: ''
        }
        setNote(addNote)
        setEdit(false)
        setOpen(true)
    }

    const remove = () => {
        if (!note) return

        let notes = s_char_notes.value;
        const foundIndex = notes.findIndex(x => x.id === note?.id);
        if (foundIndex >= 0) {
            notes.splice(foundIndex, 1);
            s_char_notes.value = notes
            NotesDelete(note)
            setNote(null)
            setOpen(false)

        }
    }

    return <Paper style={{overflowX: 'auto', marginTop: "14px"}}>
        <h3 style={{margin: "5px"}}>Notizen/Ausrüstung/etc <AddIcon onClick={() => add()}/></h3>

        <TableContainer style={{maxHeight: 185}}>
            <Table stickyHeader style={{width: '100%'}} size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Was</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                    <TableBody>{s_char_notes.value.map((row) => notesRow(row))}</TableBody>
            </Table>
        </TableContainer>
        <Dialog open={open}>
            <DialogContent>
                <TextField defaultValue={note?.entry||''}
                           inputRef={noteRef}
                           variant="standard"
                           style={{width: '100%'}}
                />
            </DialogContent>
            <DialogActions>
                <Button className={'btn'} id="post" onClick={() => save()}><CheckIcon/></Button>
                <Button className={'btn'} id="post" onClick={() => cancel()}><ClearIcon/></Button>
                <Button className={'btn'} id="post" onClick={() => remove()}>
                    <DeleteOutlineIcon/>
                </Button>
            </DialogActions>
        </Dialog>
    </Paper>


}

export default Notes;
